export const TOGGLE_SIDEBAR_COLLAPSE = '@sidebarCollapse/TOGGLE_SIDEBAR_COLLAPSE';
export const SHOW_MOBILE_SIDEBAR = '@sidebarCollapse/SHOW_MOBILE_SIDEBAR';
export const HIDE_MOBILE_SIDEBAR = '@sidebarCollapse/HIDE_MOBILE_SIDEBAR';
export const ON_SIDEBAR_DRAG_START = '@sidebarCollapse/ON_SIDEBAR_DRAG_START';
export const ON_SIDEBAR_DRAG_END = '@sidebarCollapse/ON_SIDEBAR_DRAG_END';
